import React, { useState } from "react";
import { Alert } from "@material-ui/lab";
import ChangesMakePayment from "../Changes-Make-Payments/ChangesMakePayment";
function ChangeInExtraItems(props) {
  const { ExtraItemsConfirmation, errMessage } = props;

  const [isPayment, setIsPayment] = useState(false);

  const { extra_request_items, change_item_extra, request } = props.requestData;

  const {
    extra_item_price_change,
    final_amount,
    id,
    request_timeline_status,
    discount,
  } = request;

  const handleAccept = () => {
    if (
      extra_item_price_change === null ||
      extra_item_price_change === 0 ||
      extra_item_price_change === "" ||
      request_timeline_status < 3
    ) {
      ExtraItemsConfirmation("1");
    } else {
      setIsPayment(true);
    }
  };

  if (isPayment) {
    return (
      <ChangesMakePayment
        id={id}
        amount={extra_item_price_change}
        old_amount={final_amount}
        new_amount={final_amount + extra_item_price_change}
        ChangeInRequestConfirmation={ExtraItemsConfirmation}
        discount={discount}
      />
    );
  }

  return (
    <>
      <div className="row">
        <div className="col-12 col-lg-6" id="onebox">
          <div className=" rounded-box items-info-wrapper mt-2 ">
            <div className="info-header text-center">
              <h6 className="black-color">Previous Extra Items List</h6>
            </div>
            <div className="info-detail-wrapper p-3 pt-20">
              {extra_request_items.map((item, i) => (
                <div key={i}>
                  {parseInt(item.quantity) > 0 && (
                    <div className="row pt-1 ">
                      <div className="col-9 text-left small-font-size">
                        {item.name}
                      </div>
                      <div className="col-3 small-sub-title">
                        {item.quantity}{" "}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 mt-4 mt-lg-0" id="twobox">
          <div className="rounded-box items-info-wrapper mt-2">
            <div className="info-header text-center">
              <h6 className="black-color">
                Changed Extra Items List ($
                {extra_item_price_change ? extra_item_price_change : 0})
              </h6>
            </div>
            {errMessage && (
              <Alert variant="filled" severity="error">
                {errMessage}
              </Alert>
            )}
            <div className="info-detail-wrapper p-3 pt-20">
              {change_item_extra.map((item, i) => (
                <div key={i}>
                  {item.quantity > 0 && (
                    <div className="row pt-1">
                      <div className="col-9 text-left small-font-size">
                        {item.name}
                      </div>
                      <div className="col-3 small-sub-title">
                        {item.quantity}{" "}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="col-3"></div>
        <div className="col-6 mt-1  justify-content-center d-flex">
          <button
            className="custom-btn-small custom-buton m-4"
            onClick={handleAccept}
          >
            Accept
          </button>
          <button
            className="custom-btn-small custom-buton m-4"
            onClick={() => ExtraItemsConfirmation("0")}
          >
            Reject
          </button>
        </div>
        <div className="col-3"></div>
      </div>
    </>
  );
}

export default ChangeInExtraItems;
